import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Eye, Lightbulb, Box, Users, Heart } from "lucide-react";
import './AboutUs.css';
import nobg from "../assets/images/noBG logo.png";

export default function AboutUs() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="aboutus-root" dir="rtl">
            <nav className="aboutus-nav">
                <div className="aboutus-container nav-container">
                    <Link to="/">
                        <img src={nobg} alt="أمانك - Amanak" className="navbar-logo-img" />
                    </Link>
                    <Link to="/" className="aboutus-back-link">
                        <ArrowRight size={20} />
                        الرجوع للرئيسية
                    </Link>
                </div>
            </nav>

            {/* Hero Banner */}
            <div className="aboutus-hero">
                <div className="aboutus-container">
                    <h1>أمانك.. رفيق التحول الرقمي</h1>
                </div>
            </div>

            <main className="aboutus-main">
                <div className="aboutus-container">
                    {/* من نحن */}
                    <section className="aboutus-section">
                        <h2>
                            <Eye size={24} className="section-icon" />
                            من نحن؟
                        </h2>
                        <p>
                            نحن في أمانك (Amanak)، شركة تقنية سودانية رائدة اتخذت من مدينة أمدرمان مقراً ومنطلقاً لها. نؤمن بأن المستقبل يُبنى بالابتكار، لذا كرسنا جهودنا لتطوير حلول برمجية سحابية متكاملة (ERP) تُعيد صياغة مفهوم إدارة الأعمال في السودان، مع التركيز على الكفاءة، الأمان، والسهولة.
                        </p>
                    </section>

                    {/* رؤيتنا */}
                    <section className="aboutus-section aboutus-vision">
                        <h2>
                            <Lightbulb size={24} className="section-icon" />
                            رؤيتنا
                        </h2>
                        <p>
                            أن نقود قاطرة التحول الرقمي في الأسواق السودانية، ونمكن التاجر والمصنع السوداني من إدارة أعماله بأحدث التقنيات العالمية وبأيدٍ محلية تفهم تفاصيل السوق واحتياجاته.
                        </p>
                    </section>

                    <hr className="aboutus-divider" />

                    {/* ماذا نقدم */}
                    <section className="aboutus-section">
                        <h2>
                            <Box size={24} className="section-icon" />
                            ماذا نقدم؟ (حلولنا الذكية)
                        </h2>
                        <p>
                            نحن لا نقدم مجرد برامج، بل نقدم منظومة متكاملة تعمل سحابياً (Cloud-based) لضمان وصولك لبياناتك من أي مكان في العالم، مع تخزين آمن وفائق الحماية على أقوى السيرفرات العالمية.
                        </p>
                        <ul className="aboutus-solutions-list">
                            <li>
                                <strong>نظام المبيعات والمخازن:</strong>
                                حلول ذكية لإدارة حركة البضائع، المبيعات اليومية، والتقارير المالية بدقة متناهية.
                            </li>
                            <li>
                                <strong>إدارة الإنتاج (قطاع السكر):</strong>
                                فخورون بامتلاكنا نظاماً متخصصاً لإدارة خطوط إنتاج السكر، مصمم لرفع الكفاءة وتقليل الهدر في هذا القطاع الحيوي.
                            </li>
                            <li>
                                <strong>تطبيق Amanak Manager:</strong>
                                مكتبك في جيبك! تطبيق يتيح لأصحاب العمل مراقبة محلاتهم ومخازنهم لحظة بلحظة، ومن أي مكان، لتبقى دائماً على اطلاع بما يدور في عملك.
                            </li>
                        </ul>
                    </section>

                    <hr className="aboutus-divider" />

                    {/* من يثق بنا */}
                    <section className="aboutus-section">
                        <h2>
                            <Users size={24} className="section-icon" />
                            من يثق بنا
                        </h2>
                        <p>
                            إن اختيار كبار التجار في أسواق أمدرمان العريق لنظام "أمانك" لم يكن من فراغ، بل نتيجة لـ:
                        </p>
                        <ol className="aboutus-trust-list">

                            <li>
                                <strong>المرونة:</strong> باقات متنوعة تناسب المحلات الصغيرة وصولاً إلى المصانع والشركات الكبرى.
                            </li>
                            <li>
                                <strong>الأمان:</strong> بياناتك هي رأس مالك، لذا نستخدم تقنيات تشفير وسيرفرات متطورة تضمن لك الخصوصية والاستمرارية.
                            </li>
                        </ol>
                    </section>

                    <hr className="aboutus-divider" />

                    {/* كلمتنا لشركائنا */}
                    <section className="aboutus-section aboutus-closing">
                        <h2>
                            <Heart size={24} className="section-icon" />
                            كلمتنا لشركائنا
                        </h2>
                        <p>
                            نحن عازمون على نشر ثقافة التحول الرقمي بين كافة التجار، لنسهم معاً في بناء اقتصاد سوداني قوي، حديث، ومنظم.
                        </p>
                        <p className="aboutus-tagline">
                            أمانك.. دقة في الجرد وثقة في الإدارة.
                        </p>
                    </section>
                </div>
            </main>

            <footer className="aboutus-footer">
                <div className="aboutus-container">
                    <p>© {new Date().getFullYear()} أمانك (Amanak). جميع الحقوق محفوظة.</p>
                </div>
            </footer>
        </div>
    );
}
